export const INJECTION_STATE_NOT_YET = 'NOT_YET';
export const INJECTION_STATE_IN_PROGRESS = 'IN_PROGRESS';
export const INJECTION_STATE_DONE = 'DONE';

let injectionState = INJECTION_STATE_NOT_YET;
let injectionError = null;

let onScriptLoadCallbacks = [];
let onScriptLoadErrorCallbacks = [];

let serviceInstance;
let serviceSession;
let placeDetailServiceInstance;

export const autocompletionRequestBuilder = (
  autocompletionRequest,
  input,
  sessionToken
) => {
  const google = window.google;

  const { bounds, location, ...rest } = autocompletionRequest;

  const res = {
    input,
    ...rest
  };

  if (sessionToken) {
    res.sessionToken = sessionToken;
  }

  if (bounds) {
    res.bounds = new google.maps.LatLngBounds(...bounds);
  }

  if (location) {
    res.location = new google.maps.LatLng(location);
  }

  return res;
};

export const initPlaceServiceSession = () => {
  serviceInstance = new window.google.maps.places.AutocompleteService();
  /* setServiceStatus(window.google.maps.places.PlacesServiceStatus.OK); */
  serviceSession = new window.google.maps.places.AutocompleteSessionToken();

  placeDetailServiceInstance = new window.google.maps.places.PlacesService(
    document.getElementById('map')
  );
};

export const getSessionInstances = () => {
  return {
    placesService: serviceInstance,
    sessionToken: serviceSession,
    placeDetailService: placeDetailServiceInstance
  };
};

const injectScript = apiKey => {
  switch (injectionState) {
    case INJECTION_STATE_DONE:
      return injectionError
        ? Promise.reject(injectionError)
        : Promise.resolve();

    case INJECTION_STATE_IN_PROGRESS:
      return new Promise((resolve, reject) => {
        onScriptLoadCallbacks.push(resolve);
        onScriptLoadErrorCallbacks.push(reject);
      });

    default:
      // INJECTION_STATE_NOT_YET

      injectionState = INJECTION_STATE_IN_PROGRESS;

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;

        const onScriptLoad = () => {
          // Resolve current promise
          resolve();
          // Resolve the pending promises in their respective order
          onScriptLoadCallbacks.forEach(cb => cb());

          cleanup();
        };
        const onScriptLoadError = () => {
          // Reject all promises with this error
          injectionError = new Error(
            `Could not inject Google script - ${apiKey}`
          );
          // Reject current promise with the error
          reject(injectionError);
          // Reject all pending promises in their respective order with the error
          onScriptLoadErrorCallbacks.forEach(cb => cb(injectionError));

          cleanup();
        };

        // Release callbacks and unregister listeners
        const cleanup = () => {
          script.removeEventListener('load', onScriptLoad);
          script.removeEventListener('error', onScriptLoadError);
          onScriptLoadCallbacks = [];
          onScriptLoadErrorCallbacks = [];
          injectionState = INJECTION_STATE_DONE;
        };

        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptLoadError);

        document.body.appendChild(script);
      });
  }
};

const initialize = () => {
  if (!window.google) {
    throw new Error('[google-map]: Google script not loaded');
  }
  if (!window.google.maps) {
    throw new Error('[google-map]: Google maps script not loaded');
  }
  if (!window.google.maps.places) {
    throw new Error('[google-map]: Google maps places script not loaded');
  }

  initPlaceServiceSession();
};

export const initPlaceService = async () => {
  const API_KEY = process.env.GOOGLE_API_KEY;
  try {
    await injectScript(API_KEY);
    initialize();
  } catch (error) {
    console.log('failed to load place sdk', error);
  }
};
